"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonUpload = void 0;
const React = require("react");
const bronson_react_1 = require("@vwfs-bronson/bronson-react");
const filters_1 = require("../../utils/filters/filters");
const steps_enum_1 = require("./steps.enum");
const BronsonUpload = ({ onFileChange, textButtonDefault, messages, step, inputId, accept, additionalClass, maxSizeInBytes, multiple, }) => {
    const [maxSizeError, setMaxSizeError] = React.useState(false);
    const maxSizeMessage = 'El archivo no puede ser cargado, el tamaño máximo del archivo debe ser: ';
    const onChange = (event) => {
        const file = event.target.files && event.target.files[0];
        const types = (accept && accept.split(',')) || [];
        if ((file && types.includes(file.type)) || !accept) {
            if (!maxSizeInBytes || (file && file.size <= maxSizeInBytes)) {
                setMaxSizeError(false);
                onFileChange(event);
            }
            else {
                setMaxSizeError(!!maxSizeInBytes);
            }
        }
        event.target.value = '';
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(bronson_react_1.Upload, { className: additionalClass, descriptionText: messages.initial, descriptionSupplementaryText: messages.default, buttonText: textButtonDefault, mouseoverText: messages.initial, id: inputId, onChange: onChange, accept: accept, disabledText: step === steps_enum_1.Steps.ERROR ? messages.error : messages.disabled, disabledSupplementaryText: step === steps_enum_1.Steps.DISABLED ? messages.error : '', processingText: messages.loading, mouseover: step === steps_enum_1.Steps.INITIAL, loading: step === steps_enum_1.Steps.LOADING, disabled: step === steps_enum_1.Steps.ERROR || step === steps_enum_1.Steps.DISABLED, multiple: multiple }),
        React.createElement("span", { className: 'c-error-message' }, maxSizeError &&
            maxSizeInBytes &&
            `${maxSizeMessage}${filters_1.filters.bytesToString(maxSizeInBytes)}`)));
};
exports.BronsonUpload = BronsonUpload;
